export default __webpack_public_path__ + "static/media/cabello-mujer-azul.b5d353f1.png";